import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  sessionId: z.string().min(1),
});

export type InputType = z.infer<typeof schema>;

export interface SessionPersona {
  id: string;
  name: string;
  description: string | null;
  icon: string;
  category: string;
  systemPrompt: string;
  isBuiltin: boolean;
  priority: number;
  tags: string[] | null;
  isEnabled: boolean;
  enabledBy: number;
  enabledByName: string;
}

export type OutputType = {
  personas: SessionPersona[];
};

export const getSessionPersonas = async (
  input: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const params = new URLSearchParams({ sessionId: input.sessionId });
  const result = await fetch(`/_api/personas/session/list?${params}`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });

  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }

  return superjson.parse<OutputType>(await result.text());
};
